import React, { FC, useEffect } from 'react';
import { AdditionalType, Tourney } from '../../../model/interfaces';
import {
  months,
  startIn,
} from '../../tournamentsAdditionalInfo/tournamentsAdditionalInfo';
import { TourneyTimer } from '../../tourneyTimer';

type PropsType = {
  item: Tourney;
  children?: never;
  handlerShowAdditional: (id: string, data: AdditionalType) => void;
  activeItem: string;
  index: number;
};

export const PendingTournamentsItem: FC<PropsType> = ({
  item,
  handlerShowAdditional,
  activeItem,
  index,
}: PropsType) => {
  const { TourneyID, StartTimeUTC, Name, DirectorName, EntryFee } = item;
  const time = startIn(StartTimeUTC.toString());
  const minutes =
    new Date(time).getMinutes() < 10
      ? `${new Date(time).getMinutes()}0`
      : new Date(time).getMinutes();
  const timeStart = `${months[new Date(time).getMonth()]} ${new Date(
    time
  ).getDate()}, ${new Date(time).getHours()}:${minutes}`;

  const addData: AdditionalType = {
    tourneyID: item.TourneyID,
    component: 'pending',
    directorName: item.DirectorName,
    directorId: item.Director,
    startTime: timeStart,
    checkIn: '5min prior to start',
    pairing: item.PairingType,
    timeControl: item.TimeControl,
    entryFee: item.EntryFee,
    description: item.Description,
    extraBonus: item.ExtraBonus,
    firstPrizeUsr: item.FirstPrizeUsr,
    firstPrizeAmt: item.FirstPrizeAmt,
    secondPrizeUsr: item.SecondPrizeUsr,
    secondPrizeAmt: item.SecondPrizeAmt,
    thirdPrizeUsr: item.ThirdPrizeUsr,
    thirdPrizeAmt: item.ThirdPrizeAmt,
    fourthPrizeUsr: item.FourthPrizeUsr,
    fourthPrizeAmt: item.FourthPrizeAmt,
  };

  const activeClass =
    activeItem === TourneyID
      ? 'pending__content pending__content--active'
      : 'pending__content';

  useEffect(() => {
    if (index === 0) handlerShowAdditional(TourneyID, addData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [index]);

  return (
    <div
      className={activeClass}
      onClick={() => {
        handlerShowAdditional(TourneyID, addData);
      }}
    >
      <div className="tournaments__item-title">{timeStart}</div>
      <div className="tournaments__item-rules">{Name}</div>
      <div className="tournaments__item-director">
        <div className="avatar-overlay">
          <img
            className="avatar"
            src={`https://www.gamecolony.com/cgi-bin/get_avatar.plx?uid=${item.Director}&size=2`}
            alt="avatar"
          />
        </div>
        <div className="tournaments__item-director-name">{DirectorName}</div>
      </div>
      <div className="tournaments__item-entry">{`${EntryFee} Tickets`}</div>
      <div className="tournaments__item-start tournaments__item-start--active">
        <TourneyTimer timeStart={time} />
      </div>
    </div>
  );
};
